import { graphql } from 'react-relay';
import type { FC } from 'react';
import React, { memo } from 'react';
import { css } from '@compiled/react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, xcss } from '@atlaskit/primitives';

import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';

import type {
	FeedCardActionsMenuQuery as FeedCardActionsMenuQuery$data,
	FeedCardActionsMenuQueryVariables as FeedCardActionsMenuQuery$variables,
} from './__types__/FeedCardActionsMenuQuery.ts';
import { FeedCardStarAction } from './FeedCardStarAction/index.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
const FeedCardActionsMenuQuery = graphql`
	query FeedCardActionsMenuQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			metadata {
				currentuser {
					favourited {
						isFavourite
					}
				}
			}
		}
	}
`;
const actionsWrapperStyle = css({
	display: 'flex',
	alignItems: 'center',
});

const ListItemWrapperStyles = xcss({
	listStyleType: 'none',
	margin: '0',
	padding: '0',
});

type Props = {
	contentId: string;
};

export const FeedCardActions: FC<Props> = memo(({ contentId }) => {
	const { data, error } = useQueryInterop<
		FeedCardActionsMenuQuery$data,
		FeedCardActionsMenuQuery$variables
	>(FeedCardActionsMenuQuery, {
		variables: { contentId },
	});

	const renderStarAction = () => {
		if (error) {
			return <ErrorDisplay error={error} />;
		}

		const isStarred = !!data?.singleContent?.metadata?.currentuser?.favourited?.isFavourite;
		return <FeedCardStarAction contentId={contentId} isStarred={isStarred} />;
	};

	return (
		<div css={actionsWrapperStyle} data-testid="feed-card-actions">
			<Flex as="ul" alignItems="center">
				<Box xcss={ListItemWrapperStyles} as="li">
					{renderStarAction()}
				</Box>
			</Flex>
		</div>
	);
});
